// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.student-search-container {
  border-radius: 10px;
  background: #EDF0F1;
  padding: 0 10px;
}
.student-search-container p {
  font-weight: 550;
}
.student-search-container .student-search {
  display: flex;
  flex-direction: column;
}
.student-search-container .student-search input[type=text] {
  border-radius: 5px;
  border: 1px solid #A7A9AC;
  width: 370px;
  padding: 4px;
}
.student-search-container .input-heading {
  color: #0669B3;
  font-size: 1.2em;
  font-weight: 600;
}

.display-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}
.display-container .epr-links-container {
  display: flex;
  flex-direction: column;
  width: 50%;
}
.display-container .epr-links-container .epr-link {
  font-weight: 500;
  margin: 10px;
  min-width: 400px;
  text-align: left;
  white-space: collapse;
}
.display-container .epr-links-container .spare-div {
  display: inline-block;
}
.display-container .epr-links-container .spare-div .epr-link {
  width: 97.25%;
}
.display-container .results-container {
  display: flex;
  flex: 999 0 400px;
  flex-direction: column;
  font-size: 0.9rem;
  min-width: 400px;
  white-space: collapse;
}
.display-container .results-container .error {
  color: red;
}
.display-container .results-container .success {
  color: green;
}

.back-to-dashboard {
  margin-top: 10px;
}

.grey-background {
  border-radius: 10px;
  background-color: #EDF0F1;
  padding: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/EprLinks.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,mBDCsB;EACtB,mBDqBI;ECpBJ,eAAA;AAUJ;AARI;EACI,gBAAA;AAUR;AAPI;EACI,aAAA;EACA,sBAAA;AASR;AARQ;ECZJ,kBDa8B;EACtB,yBAAA;EACA,YAAA;EACA,YAAA;AAUZ;AAPI;EACI,cDUK;ECTL,gBAAA;EACA,gBAAA;AASR;;AALA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;AAQJ;AAPI;EACI,aAAA;EACA,sBAAA;EACA,UAAA;AASR;AARQ;EACI,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAUZ;AARQ;EACI,qBAAA;AAUZ;AATY;EACI,aAAA;AAWhB;AAPI;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;AASR;AARQ;EACI,UAAA;AAUZ;AARQ;EACI,YAAA;AAUZ;;AANA;EACI,gBAAA;AASJ;;AANA;ECrEI,mBDsEsB;EACtB,yBDhDI;ECiDJ,aAAA;AASJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.student-search-container {\n    @include borderRadius(10px);\n    background: $grey0;\n    padding: 0 10px;\n\n    p {\n        font-weight: 550;\n    }\n\n    .student-search {\n        display: flex;\n        flex-direction: column;\n        input[type=\"text\"] {\n            @include borderRadius(5px);\n            border: 1px solid $grey2;\n            width: 370px;\n            padding: 4px;\n        }\n    }\n    .input-heading {\n        color: $pearl-blue;\n        font-size: 1.2em;\n        font-weight: 600;\n    }\n}\n\n.display-container {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    width: 100%;\n    .epr-links-container {\n        display: flex;\n        flex-direction: column;\n        width: 50%;\n        .epr-link {\n            font-weight: 500;\n            margin: 10px;\n            min-width: 400px;\n            text-align: left;\n            white-space: collapse;\n        }\n        .spare-div {\n            display: inline-block;\n            .epr-link {\n                width: 97.25%;\n            }\n        }\n    }\n    .results-container {\n        display: flex;\n        flex: 999 0 400px;\n        flex-direction: column;\n        font-size: 0.9rem;\n        min-width: 400px;\n        white-space: collapse;\n        .error {\n            color: red;\n        }\n        .success {\n            color: green;\n        }\n    }\n}\n.back-to-dashboard {\n    margin-top: 10px;\n}\n\n.grey-background {\n    @include borderRadius(10px);\n    background-color: $grey0;\n    padding: 10px;\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
